<template>
<div class="vcs-shop-header ">

<!--  <li v-for="item in menuQuery.entries" :key="item.title">-->
<!--    {{ item.title }}-->
<!--    {{item.__typename}}-->
<!--  </li>-->


  <div v-for="item in menu.entries" :key="item.title" v-if="item.level === 1">






    <div class="h-full" @mouseenter.passive="hovered = item.c7Slug"  v-if="item.children[0]"  >
      <a  v-if="currentPage(item)" id="item.c7Slug" class="uppercase font-TT highlighted-menu text-font-title relative shop-menu" :href="'/collection/' + item.c7Slug"> {{item.title}}</a>
      <a  v-else-if="childMatch(item)" id="item.c7Slug" class="uppercase font-TT highlighted-menu text-font-title relative shop-menu" :href="'/collection/' + item.c7Slug"> {{item.title}}</a>
      <a  v-else-if="homeMatch(item)" class="uppercase font-TT text-font-title relative shop-menu" href="/shop"> {{item.title}}</a>
      <a  v-else class="uppercase font-TT text-font-title shop-menu" :href="'/collection/'  + item.c7Slug"> {{item.title}}</a>
      <div v-if="hovered === item.c7Slug" @mouseleave="hovered = ''"  class="children absolute" style="width: 200px;
      display:flex;
  flex-wrap: wrap;
  margin-top: 1rem;
  background: #f5f1eb;
  border: 1.5rem solid #f5f1eb;
  margin-left: -1.5rem;">
        <a v-for="child in item.children" class="uppercase font-TT text-font-title w-full shop-menu" :href="'/collection/' + child.slug"> {{child.title}}</a>
      </div>
    </div>
    <div @mouseleave="hovered = ''"  v-else >
      <a  v-if="currentPage(item)" id="item.c7Slug" class="uppercase font-TT highlighted-menu text-font-title shop-menu" :href="'/collection/' + item.c7Slug"> {{item.title}}</a>
      <a  v-else class="uppercase font-TT text-font-title shop-menu" :href="'/collection/'  + item.c7Slug"> {{item.title}}</a>
    </div>

<!--    <a v-if="item.level === 1"> {{item.title}} </a>-->

  </div>




</div>
</template>
<script>
import gql from 'graphql-tag'
export default {
  name: "ShopMenu",
  props: {
    page:{
      type: String,
      default:''
    }
  },
  apollo: {
    // menuQuery: {
    //   query: gql`query getMenu {
    //     entries(section:"shopMenu") {
    //       ...on shopMenu_default_Entry{
    //         title
    //         sortOrderMenu
    //
    //       }
    //       ... on shopMenu_white_Entry {
    //         title
    //         sortOrderMenu
    //       }
    //       ... on shopMenu_red_Entry {
    //         title
    //         sortOrderMenu
    //       }
    //     }
    //   }`,
    //   update: data => data,
    //
    // },
    menu: {
      query: gql`query c7MenuEntries {
        entries(section:"c7Menu") {
          ... on c7Menu_default_Entry {
            id
            children {
              title
              level
              slug
            }
            c7Slug
            title
            level
            sortOrderMenu
          }

        }
      }`,
      update: data => data,

    },
  },
  data() {
    return {
      menuQuery: {
        entries: []
      },
      menu : {
        entries: []
      },
      hovered: '',
      reds: ['gamay','pinot-noir','cabernet-franc'],
      whites: ['gewürztraminer','pinot-gris','chardonnay','riesling']
    }
  },

  methods: {
    currentPage: function(item) {
     console.log(item.title);
     console.log(this.page)
      return item.c7Slug.toLowerCase() === this.page.toLowerCase();

    },
    childMatch: function(item) {
      console.log("child Match" + item.title + this.page);
      if(item.title === 'Red') {
        for(let i = 0; i < this.reds.length; i++) {
          console.log('item c7 slug' + item.c7Slug);
          if(this.page === this.reds[i]) {
            return true;
          }
        }
        return false;
      }

      if(item.title === 'White') {
        for(let i = 0; i < this.whites.length; i++) {
          if(this.page === this.whites[i]) {
            return true;
          }
        }
        return false;
      }
    },
    homeMatch: function(item) {
      return item.c7Slug.toLowerCase() === 'home';
    },
    menuSort:function(menu) {
      console.log(menu.entries);
      return menu.entries.sort((a, b) => {a.sortOrderMenu - b.sortOrderMenu });
    }
  },

  created() {
    console.log(this.pageroute);
  }


}
</script>


